import { render, staticRenderFns } from "./leuco-pdpa.vue?vue&type=template&id=cbd09260&"
import script from "./leuco-pdpa.vue?vue&type=script&lang=js&"
export * from "./leuco-pdpa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports